<template>
  <div>
    <div class="grid">
      <div 
        class="grid__item" 
        v-for="item in localItems" 
        :key="item.id" 
        v-metrik-click="(e) => sendStat(e, 'clickEventYM', item.name )"
        >
        <a :href="item.detailPageUrl" class="event-card event-card_alt">
          <div class="event-card__top">
            <div v-if="item.category && item.category.length > 0" class="event-card__note" v-html="item.category"></div>
            <div class="event-card__text"><h2><span v-html="item.name"></span></h2></div>
          </div>
          <div class="event-card__bottom">
            <div class="event-card__bottom-text" v-html="item.description"></div>
            <div class="event-card__image" v-if="item.detailPicture && item.detailPicture.length > 0">
              <img :src="item.detailPicture" :alt="item.name" />
            </div>
          </div>
        </a>
      </div>
    </div>
    <a
      v-if="showMoreButton"
      :class="['more-button', {'more-button_loading': loading}]"
      :href="`/?PAGEN_${paginator.navNum}=${currentPage + 1}`"
      @click.prevent="loadItems(currentPage + 1)"
    >
      <template v-if="!loading">{{ moreMsg }}</template>
      <template v-else>
        <img src="/frontend/assets/img/loader2.gif" alt=""/>
      </template>
    </a>
  </div>
</template>

<script>
import axios from 'axios';
import YMStat from "../tools/ymStat";

export default {
  name: 'EventsList',
  props: {
    moreMsg: {
      type: String,
      default: 'Ещё',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    paginator: {
      type: Object,
      default() {
        return {
          navNum: 0,
          navPageNomer: 0,
          navPageCount: 0,
          navRecordCount: 0,
          navPageSize: 0,
        };
      },
    },
  },
  data() {
    return {
      currentPage: this.paginator.navPageNomer,
      loading: false,
      localItems: this.items,
      pageNav: this.paginator,
    }
  },
  computed: {
    showMoreButton() {
      return this.pageNav.navPageNomer < this.pageNav.navPageCount;
    },
  },
  methods: {
    async loadItems(page) {
      const pagen = this.pageNav.navNum;
      this.loading = true;

      const response = await axios({
        url: location.pathname + `?PAGEN_${pagen}=${page}&ajax=Y`,
        method: 'GET',
      });

      const uniqId = [];
      const uniqItems = [...this.localItems, ...response.data.items].reduce((acc, curr) => {
        const isNotUniq = uniqId.some((item) => item === curr.id);

        if (isNotUniq) {
          return acc;
        }

        uniqId.push(curr.id);
        acc.push(curr);
        return acc;
      }, [])


      this.localItems = uniqItems;
      this.pageNav = response.data.paginator;
      this.currentPage++;
      this.loading = false;
      if (response.data.paginator.navPageCount === response.data.paginator.navPageNomer) {
        this.showMoreButton = false;
      }
    },
    sendStat(e, param, value){
      YMStat[param](value)
    },
  },
}
</script>
